export default "__VITE_ASSET__deZMSwaH__"